
























import { checkSelfRole, isSuperAdmin } from "@/common/role_utils";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class ReportLayout extends Vue {
  isOwner = checkSelfRole("owner") || isSuperAdmin();

  created() {
    if (this.isOwner && this.$route.path.endsWith("admin")) {
      this.$router.replace({ path: "/expense-report/owner" });
    }
  }

  get isCategory() {
    return this.$route.params.departmentId;
  }

  get isCompany() {
    return this.isOwner && this.$route.path.endsWith("owner");
  }
}
